<script>
    import { createEventDispatcher, afterUpdate } from 'svelte';
    import { fade } from 'svelte/transition'
    
    const dispatch = createEventDispatcher();

    export let isOpenModal;
    export let darkmode;
    export let calendar;
    export let seqId;

    function closeModal() {
        isOpenModal = false;
        dispatch('closeModal', { isOpenModal });
    }
    afterUpdate(() => {
        if(isOpenModal){
            //focus somewhere?
        }
    })

</script>

{#if isOpenModal}
<div id="background" on:click={closeModal} transition:fade></div>
<div id="modal" transition:fade>
    <h5>Ampersandi Archive</h5>
    <h4 class="archiverowspace">
        <span>Date</span>
        <span><!--Diff--></span>
        <span>Tries</span>
        <span>Hints</span>
    </h4>
    <ol id="archivelist">
        {#each calendar as puzz}
            <li class="archiverowspace" class:completed={puzz.completed} class:started={puzz.started} class:revealed={puzz.revealed} on:click={()=>{window.location.href = "/?p="+puzz.seqId}}>
                <span class="puzzID">{puzz.golivedate}</span>
                <span><!--!!--></span>
                <span class="rtflt">
                {#if puzz.completed}
                    {"&".repeat(puzz.tries > 5 ? 5 : puzz.tries) + (puzz.tries > 5 ? "+":"")}
                {:else}
                    N/A
                {/if}
                </span>
                <span class="rtflt">
                    {puzz.completed ? "?:" + (puzz.hints ? puzz.hints : "0") : "N/A"}
                </span>
            </li>
        {/each}
    </ol>
    <div id="buttonarea">
        <button id="cancelcalendar" type="button" class="submitbtn" on:click={closeModal}>Cancel</button>
    </div>
</div>
{/if}

<style>
    #background {
        display: block;
        position: fixed;
        z-index: 10;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: var(--fg-color);
        opacity: 0.6;
    }

    #modal {
        display: block;
        position: absolute;
        padding:15px;
        z-index: 12;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: var(--bg-color);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        max-width:300px;
        width:100%;
        max-height:400px;
        height:100%
    }
    h5 {
        font-family: 'Georgia';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 14px;
        letter-spacing: 0.18em;
        margin-top: 5px;
        margin-bottom: 5px;
        color: var(--fg-color);
        padding-top:0px;
    }
    #archivelist{
        list-style-type: none;
        padding: 0px;
        display:flex;
        flex-direction: column;
        overflow: auto;
        max-height:350px;
        margin-top:0px;
    }
    #archivelist li{
        padding:10px;
        border-radius: 5px;
        border: 1px solid var(--fg-color);
        margin-top: 10px;
        color: var(--fg-color);
        font-family: 'Georgia';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 14px;
        letter-spacing: 0.18em;
        align-items: center;
        cursor: pointer;

    }
    #archivelist li span{
        width:100%;
    }
    .archiverowspace{
        display:grid;
        grid-template-columns: 90px 40px 90px 50px;
    }
    #archivelist li:last-of-type{
        margin-bottom:60px;
    }
    #archivelist li.started{
        border: 2px dashed var(--accent);
    }
    #archivelist li.completed{
        background-color: #009050;
        color: #FFFFFF;
        border: 1px solid #009050;
    }
    #archivelist li.revealed{
        background-color: transparent;
        border: 2px solid var(--revealed);
        color: var(--fg-color);
    }
    .puzzID{
        margin-right:auto;
    }
    #buttonarea{
        width:100%;
        max-width:300px;
        height:90px;
        position:absolute;
        bottom:0px;
        display:flex;
        align-items: flex-end;
        padding-bottom:10px;
        background: linear-gradient(0deg,var(--bg-color),var(--bg-color) 70%, transparent);
    }

</style>